export default __webpack_public_path__ + "static/media/demo.36c687e8.png";